import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  const painPoints = [{
    emoji: '🧠',
    text: 'Tu mente no para cuando te acuestas'
  }, {
    emoji: '😶',
    text: 'Estás presente pero sientes que no estás'
  }, {
    emoji: '😤',
    text: 'Te irritas por cosas pequeñas sin razón'
  }, {
    emoji: '☁️',
    text: 'Niebla mental — no puedes concentrarte ni recordar'
  }, {
    emoji: '😮‍💨',
    text: 'Agotamiento que no desaparece con descanso'
  }, {
    emoji: '💔',
    text: 'Perdiste la motivación por cosas que antes amabas'
  }];
  return <section className="py-20 bg-brand-light-sage" data-id="element-135" data-mp="3jdzbyirera84">
      <div className="max-w-5xl mx-auto px-6" data-id="element-136" data-mp="3egpfij5lpyas">
        <FadeIn data-id="element-137" data-mp="3eew46qk1mpwg">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-forest text-center mb-12" data-id="element-138" data-mp="1p214al8qymec">
            ¿Reconoces alguna de estas señales?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-139" data-mp="1k5antwt15ose">
          {painPoints.map((point, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-140" data-mp="obopcruu33hz" data-mpi={index}>
              <div className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 h-full flex items-start gap-4" data-id="element-141" data-mp="oa3t8xsvfci0">
                <span className="text-2xl flex-shrink-0" data-id="element-142" data-mp="x51rmkesfhgq">{point.emoji}</span>
                <p className="text-brand-charcoal font-medium leading-snug" data-id="element-143" data-mp="123lc0gdqgl6z">
                  {point.text}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-144" data-mp="174ir2k3g4z49">
          <div className="text-center max-w-2xl mx-auto" data-id="element-145" data-mp="1c1j093vlehzl">
            <p className="text-xl md:text-2xl font-bold text-brand-forest leading-relaxed" data-id="element-146" data-mp="1bzy5bd5d8x17">
              Si te identificas con varias de estas señales,
              <br data-id="element-147" data-mp="3du75tjvplhij" />
              quizá sea momento de reducir la sobrecarga
              <br data-id="element-148" data-mp="3hu7j3172nmo0" />
              y revisar tus hábitos con más intención.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}